export default {"src":"/_next/static/media/empty-stage.9bb84bdd.svg","height":178,"width":150};